import { render, staticRenderFns } from "./PowerCompanies.vue?vue&type=template&id=0feef29c&scoped=true"
import script from "./PowerCompanies.vue?vue&type=script&lang=js"
export * from "./PowerCompanies.vue?vue&type=script&lang=js"
import style0 from "./PowerCompanies.vue?vue&type=style&index=0&id=0feef29c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feef29c",
  null
  
)

export default component.exports